import React from 'react';

export const useFocusTrap = (active: boolean) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!active || !ref?.current) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      const focusableElements =
        ref.current?.querySelectorAll(
          'a, button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ) || [];

      const filteredFocusableElements = Array.from(focusableElements).filter(
        (el) => (el as HTMLElement).offsetParent !== null,
      );

      if (!focusableElements) return;

      const firstElement = filteredFocusableElements.at(0) as HTMLElement;
      const lastElement = filteredFocusableElements.at(-1) as HTMLElement;

      if (!ref.current?.contains(document.activeElement)) {
        firstElement?.focus();
      }

      if (event.key === 'Tab') {
        if (event.shiftKey && document.activeElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [active]);

  return {
    ref,
  };
};
